const AUTH = {
  LOGIN_INIT: "INIT_LOGIN",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_ERROR: "LOGIN_ERROR",
};

const LANG = {
  LANG_INIT: "INIT_LANG",
  LANG_SUCCESS: "LANG_SUCCESS",
  LANG_ERROR: "LANG_ERROR",
};

export { AUTH, LANG };
